/* CCS Mobile PDP Image Lightbox
   Fullscreen image viewer for mobile (≤750px) with pinch-zoom, swipe nav,
   double-tap zoom, swipe-down to close, and history-back integration.
   Desktop is untouched — Dawn's product-media-modal handles >750px. */
(function () {
  'use strict';

  var BP = 750;
  var mq = window.matchMedia('(max-width: ' + BP + 'px)');

  var lb, track, slides, totalEl, currentEl, closeBtn, trigger, prevBtn, nextBtn;
  var total = 0, current = 0, slideW = 0;
  var scale = 1, tx = 0, ty = 0;
  var minScale = 1, maxScale = 4, doubleTapScale = 2.5;

  var pinchStartDist = 0, pinchStartScale = 1;
  var panStartX = 0, panStartY = 0, panStartTx = 0, panStartTy = 0;
  var swipeStartX = 0, swipeStartY = 0, swipeStartTime = 0;
  var swipeMode = null; /* 'horizontal' | 'vertical' | 'pan' | 'pinch' | null */
  var lastTapTime = 0, lastTapX = 0, lastTapY = 0;

  var historyPushed = false;
  var savedScrollY = 0;

  function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

  function dist(t1, t2) {
    var dx = t1.clientX - t2.clientX;
    var dy = t1.clientY - t2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function init() {
    lb = document.getElementById('ccs-lightbox');
    if (!lb) return;
    track = document.getElementById('ccs-lightbox-track');
    slides = lb.querySelectorAll('.ccs-lightbox-slide');
    totalEl = lb.querySelector('.ccs-lightbox-total');
    currentEl = lb.querySelector('.ccs-lightbox-current');
    closeBtn = lb.querySelector('.ccs-lightbox-close');
    total = slides.length;
    if (!total) return;

    /* Inline swipe gallery (2026-06-11): when the PDP renders the multi-image
       track, any slide opens the lightbox at that slide's index. Legacy
       single-image binding kept as the fallback. */
    var inlineTrack = document.getElementById('pdp-img-track');
    if (inlineTrack) {
      inlineTrack.addEventListener('click', function (e) {
        var slide = e.target && e.target.closest ? e.target.closest('.pdp-img-slide') : null;
        if (!slide) return;
        e.preventDefault();
        open(parseInt(slide.getAttribute('data-idx'), 10) || 0);
      }, false);
    } else {
      trigger = document.getElementById('pdp-main-img');
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          open(currentThumbIdx());
        }, false);
      }
    }

    if (closeBtn) closeBtn.addEventListener('click', close, false);

    /* Desktop nav arrows (mouse users). Touch users swipe; these are hidden ≤750px. */
    prevBtn = lb.querySelector('.ccs-lightbox-prev');
    nextBtn = lb.querySelector('.ccs-lightbox-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { nav(-1); }, false);
    if (nextBtn) nextBtn.addEventListener('click', function () { nav(1); }, false);

    /* Keyboard: Esc closes, arrows navigate (desktop) */
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('ccs-lightbox--open')) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowLeft') { nav(-1); }
      else if (e.key === 'ArrowRight') { nav(1); }
    });

    track.addEventListener('touchstart', onTouchStart, { passive: false });
    track.addEventListener('touchmove', onTouchMove, { passive: false });
    track.addEventListener('touchend', onTouchEnd, { passive: false });
    track.addEventListener('touchcancel', onTouchEnd, { passive: false });

    window.addEventListener('popstate', function () {
      if (lb.classList.contains('ccs-lightbox--open')) {
        historyPushed = false; /* the back already happened */
        close();
      }
    });

    window.addEventListener('resize', function () {
      if (!lb.classList.contains('ccs-lightbox--open')) return;
      slideW = window.innerWidth;
      scale = 1; tx = 0; ty = 0;
      applySlideTransform(false);
      applyTrack(false);
    });
  }

  function currentThumbIdx() {
    var active = document.querySelector('.pdp-thumb-active');
    if (!active) return 0;
    var thumbs = document.querySelectorAll('.pdp-thumb');
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i] === active) return i;
    }
    return 0;
  }

  function nav(dir) {
    var n = clamp(current + dir, 0, total - 1);
    if (n === current) return;
    current = n;
    scale = 1; tx = 0; ty = 0;
    resetAllSlideTransforms();
    applyTrack(true);
    applySlideTransform(false);
    updateCounter();
  }

  function open(idx) {
    slideW = window.innerWidth;
    current = clamp(idx || 0, 0, total - 1);
    scale = 1; tx = 0; ty = 0;
    applyTrack(false);
    applySlideTransform(false);
    updateCounter();

    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.classList.add('ccs-lightbox-lock');

    lb.classList.add('ccs-lightbox--open');
    lb.setAttribute('aria-hidden', 'false');

    if (!historyPushed) {
      try {
        history.pushState({ ccsLightbox: true }, '');
        historyPushed = true;
      } catch (e) {}
    }
  }

  function close() {
    lb.classList.remove('ccs-lightbox--open');
    lb.setAttribute('aria-hidden', 'true');
    lb.style.background = '';

    document.body.classList.remove('ccs-lightbox-lock');
    document.body.style.top = '';
    window.scrollTo(0, savedScrollY);

    scale = 1; tx = 0; ty = 0;
    applySlideTransform(false);

    if (historyPushed) {
      try { history.back(); } catch (e) {}
      historyPushed = false;
    }
  }

  function updateCounter() {
    if (currentEl) currentEl.textContent = (current + 1);
  }

  function applyTrack(snap) {
    if (!track) return;
    if (snap) track.classList.add('ccs-lightbox-track--snap');
    else track.classList.remove('ccs-lightbox-track--snap');
    track.style.transform = 'translate3d(' + (-current * slideW) + 'px, 0, 0)';
  }

  function applySlideTransform(snap) {
    var slide = slides[current];
    if (!slide) return;
    var img = slide.querySelector('img');
    if (!img) return;
    if (snap) slide.classList.add('ccs-lightbox-slide--zoom-snap');
    else slide.classList.remove('ccs-lightbox-slide--zoom-snap');
    img.style.transform = 'translate3d(' + tx + 'px, ' + ty + 'px, 0) scale(' + scale + ')';
  }

  /* Reset all zoom state on non-current slides so they start fresh */
  function resetAllSlideTransforms() {
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (img && i !== current) {
        img.style.transform = '';
        slides[i].classList.remove('ccs-lightbox-slide--zoom-snap');
      }
    }
  }

  function onTouchStart(e) {
    if (e.touches.length === 2) {
      e.preventDefault();
      pinchStartDist = dist(e.touches[0], e.touches[1]);
      pinchStartScale = scale;
      swipeMode = 'pinch';
      return;
    }
    if (e.touches.length === 1) {
      var t = e.touches[0];
      if (scale > 1.02) {
        panStartX = t.clientX; panStartY = t.clientY;
        panStartTx = tx; panStartTy = ty;
        swipeMode = 'pan';
      } else {
        swipeStartX = t.clientX; swipeStartY = t.clientY;
        swipeStartTime = Date.now();
        swipeMode = null;
      }

      /* Double-tap detection */
      var now = Date.now();
      if (now - lastTapTime < 280 &&
          Math.abs(t.clientX - lastTapX) < 30 &&
          Math.abs(t.clientY - lastTapY) < 30) {
        e.preventDefault();
        toggleDoubleTapZoom(t.clientX, t.clientY);
        lastTapTime = 0;
        swipeMode = 'doubletap';
      } else {
        lastTapTime = now;
        lastTapX = t.clientX;
        lastTapY = t.clientY;
      }
    }
  }

  function onTouchMove(e) {
    if (e.touches.length === 2 && pinchStartDist > 0) {
      e.preventDefault();
      var d = dist(e.touches[0], e.touches[1]);
      scale = clamp(pinchStartScale * (d / pinchStartDist), minScale, maxScale);
      applySlideTransform(false);
      return;
    }
    if (e.touches.length !== 1) return;
    var t = e.touches[0];

    if (swipeMode === 'pan') {
      e.preventDefault();
      tx = panStartTx + (t.clientX - panStartX);
      ty = panStartTy + (t.clientY - panStartY);
      applySlideTransform(false);
      return;
    }
    if (swipeMode === 'doubletap') return;

    var dx = t.clientX - swipeStartX;
    var dy = t.clientY - swipeStartY;
    if (swipeMode === null) {
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
        swipeMode = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical';
      }
    }
    if (swipeMode === 'horizontal') {
      e.preventDefault();
      track.classList.remove('ccs-lightbox-track--snap');
      track.style.transform = 'translate3d(' + (-current * slideW + dx) + 'px, 0, 0)';
    } else if (swipeMode === 'vertical') {
      e.preventDefault();
      var pulled = Math.max(0, dy); /* only respond to downward */
      var opacityFactor = Math.max(0.35, 1 - pulled / 500);
      lb.style.background = 'rgba(8, 8, 12, ' + (0.96 * opacityFactor) + ')';
      track.classList.remove('ccs-lightbox-track--snap');
      track.style.transform = 'translate3d(' + (-current * slideW) + 'px, ' + pulled + 'px, 0)';
    }
  }

  function onTouchEnd(e) {
    if (swipeMode === 'pinch') {
      if (scale < 1.05) { scale = 1; tx = 0; ty = 0; }
      if (scale > maxScale) scale = maxScale;
      applySlideTransform(true);
      pinchStartDist = 0;
      swipeMode = null;
      return;
    }
    if (swipeMode === 'pan') {
      applySlideTransform(true);
      swipeMode = null;
      return;
    }
    if (swipeMode === 'doubletap') {
      swipeMode = null;
      return;
    }
    var changed = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : null;
    if (!changed) { swipeMode = null; return; }

    if (swipeMode === 'horizontal') {
      var dx = changed.clientX - swipeStartX;
      var elapsed = Date.now() - swipeStartTime;
      var threshold = slideW * 0.22;
      var fast = elapsed < 250 && Math.abs(dx) > 40;
      if ((dx > threshold || (fast && dx > 0)) && current > 0) {
        current--;
        resetAllSlideTransforms();
      } else if ((dx < -threshold || (fast && dx < 0)) && current < total - 1) {
        current++;
        resetAllSlideTransforms();
      }
      applyTrack(true);
      updateCounter();
      swipeMode = null;
      return;
    }
    if (swipeMode === 'vertical') {
      var dy = changed.clientY - swipeStartY;
      if (dy > 100) {
        close();
      } else {
        track.classList.add('ccs-lightbox-track--snap');
        track.style.transform = 'translate3d(' + (-current * slideW) + 'px, 0, 0)';
        lb.style.background = '';
      }
      swipeMode = null;
      return;
    }
    swipeMode = null;
  }

  function toggleDoubleTapZoom(cx, cy) {
    if (scale > 1.05) {
      scale = 1; tx = 0; ty = 0;
    } else {
      var slide = slides[current];
      var img = slide.querySelector('img');
      if (!img) return;
      var rect = img.getBoundingClientRect();
      var imgCenterX = rect.left + rect.width / 2;
      var imgCenterY = rect.top + rect.height / 2;
      var s = doubleTapScale;
      tx = (1 - s) * (cx - imgCenterX);
      ty = (1 - s) * (cy - imgCenterY);
      scale = s;
    }
    applySlideTransform(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
